import styles from '../styles/serviceLevelTable.module.scss';
import { useTranslation } from 'next-i18next';
import { tableHeadDataUp, tableHeadDataDown } from '../constants/tableData';

function ServiceLevelsTable () {
  const { t } = useTranslation('serviceLevels');

  return(
    <section className={styles.table_service_levels}>
      <table>
        <thead >
          <tr>
            {
              tableHeadDataUp.map((item, index) => <th key={index} colSpan={t(item.colspan)} rowSpan={t(item.rowspan)}>{t(item.name)}</th>)
            }
          </tr> 
          <tr>
            {
              tableHeadDataDown.map((item, index) => <th key={index} colSpan={t(item.colspan)} rowSpan={t(item.rowspan)}>{t(item.name)}</th>)
            }
          </tr>
        </thead>
        <tbody>
          {
            new Array(15).fill('').map((_trItem, trIndex) => <tr key={trIndex}>
              { new Array(5).fill('').map((_tdItem, tdIndex) => (
                <td key={tdIndex} dangerouslySetInnerHTML={{ __html: t(`${trIndex + 1}_row.${tdIndex + 1}_col`) }} /> ))}</tr>)
          }
        </tbody>
      </table>
    </section>
  )
}

export default ServiceLevelsTable
